import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApplicationParams } from '../interfaces/application-login-params.interface';

@Injectable({
	providedIn: 'root',
})
export class ApplicationLoginParamsService {
	private readonly url: string = 'applicationParams';

	constructor(private http: HttpClient) {}

	public getParams(applicationId: number): Observable<ApplicationParams> {
		return this.http.get<ApplicationParams>(this.url + '/getApplicationParams/' + applicationId);
	}

	public saveParams(params: ApplicationParams) {
		return this.http.post<ApplicationParams>(this.url + '/saveApplicationParams/', params);
	}
}
